<template>
  <div class="d2-layout-header-aside-menu-side">
    <el-menu
      :collapse="isMenuAsideCollapse"
      :unique-opened="true"
      :default-active="active"
      ref="menu"
      @select="handleMenuSelect">
      <template v-for="(menu, menuIndex) in menuAside">
        <d2-layout-header-aside-menu-item v-if="menu.children === undefined" :menu="menu" :key="menuIndex"/>
        <d2-layout-header-aside-menu-sub v-else :menu="menu" />
      </template>
    </el-menu>
    <div v-if="menuAside.length === 0 && !isMenuAsideCollapse" flex="dir:top main:center cross:center" class="d2-layout-header-aside-menu-empty">
      <d2-icon name="inbox"/>
      <span>没有侧栏菜单</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import menuMixin from '../mixin/menu'
import d2LayoutMainMenuItem from '../components/menu-item/index.vue'
import d2LayoutMainMenuSub from '../components/menu-sub/index.vue'
import BScroll from 'better-scroll'
export default {
  name: 'd2-layout-header-aside-menu-side',
  mixins: [
    menuMixin
  ],
  components: {
    'd2-layout-header-aside-menu-item': d2LayoutMainMenuItem,
    'd2-layout-header-aside-menu-sub': d2LayoutMainMenuSub
  },
  data () {
    return {
      active: '',
      asideHeight: 300,
      BS: null,
      // 定义路由名到菜单路径的映射关系
      routeToMenuMap: {
        'dashboard': '/dashboard',
        'user-balancelist': '/user-balancelist',
        'user-recharge': '/user-balancelist', // 如果充值页也应激活余额列表，则这样设置
        'userOrdin-billing-month': '/userOrdin-billing-month',
        'user-list': '/user-list',
        'user-billing-month': '/user-billing-month',
        'user-billing-day': '/user-billing-month', // 当天账单页面激活月账单菜单项
        'user-billing-details': '/user-billing-month', // 明细页面激活月账单菜单项
        'resourceRequestDetails': '/api/resource-requests', // 资源请求详情页激活资源请求列表菜单项
        'computeProductDetails': '/api/compute-products', // 算力规格详情页激活算力规格列表菜单项
        'billShowDetails': '/api/bill-show' // 账单详情页激活账单列表菜单项
      }
    }
  },
  computed: {
    ...mapState({
      menuAside: state => state.d2admin.menuAside,
      isMenuAsideCollapse: state => state.d2admin.isMenuAsideCollapse
    })
  },
  watch: {
    // 折叠和展开菜单的时候销毁 better scroll
    isMenuAsideCollapse (val) {
      this.scrollDestroy()
      setTimeout(() => {
        this.scrollInit()
      }, 500)
    },
    // 监听路由 控制侧边栏激活状态
    /*'$route.matched': {
      handler (val) {
        this.active = val[val.length - 1].path
        this.$nextTick(() => {
          if (this.menuAside.length > 0) {
            this.$refs.menu.activeIndex = this.active
          }
        })
      },
      immediate: true
    }*/
      '$route': {
          handler (val) {
              console.log('侧边栏菜单信息11:',val.path,val.fullPath)

              // 使用映射关系找到对应的主菜单项
              const mappedPath = this.routeToMenuMap[val.name];
              if (mappedPath) {
                this.active = mappedPath;
              } else {
                // 如果没有找到映射，则默认使用 fullPath
                this.active = val.fullPath;
              }

              if(this.active.endsWith('/')){
                  this.active = this.active.substr(0,this.active.length-1);
              }
              this.$nextTick(() => {
                  if (this.menuAside.length > 0) {
                      this.$refs.menu.activeIndex = this.active
                  }
              })
          },
          immediate: true
      }
  },
  mounted () {
    this.scrollInit()
  },
  beforeDestroy () {
    this.scrollDestroy()
  },
  methods: {
    scrollInit () {
      this.BS = new BScroll(this.$el, {
        mouseWheel: true,
        click: true,
        // 如果你愿意可以打开显示滚动条
        scrollbar: {
          fade: true,
          interactive: false
        }
      })
    },
    scrollDestroy () {
      if (this.BS) {
        this.BS.destroy()
      }
    }
  }
}
</script>
